// Copied unchanged from PandahubClientNextJs lib/whenIdle.ts @ cc6f993bbc77ccae7128d9035ecb997b28e7c9f4 by scripts/sheet-sync.sh; do not edit by hand.
export function whenIdle(run: () => void, timeout = 2000): () => void {
  let cancel = () => {};
  const schedule = () => {
    if (typeof requestIdleCallback === "function") {
      const id = requestIdleCallback(run, { timeout });
      cancel = () => cancelIdleCallback(id);
    } else {
      const id = setTimeout(run, timeout);
      cancel = () => clearTimeout(id);
    }
  };
  // requestIdleCallback alone also fires in the network gaps before LCP; waiting for load keeps the work after it.
  if (document.readyState === "complete") schedule();
  else {
    window.addEventListener("load", schedule, { once: true });
    cancel = () => window.removeEventListener("load", schedule);
  }
  return () => cancel();
}
